'use strict';
const angular = require('angular');

export class sectionHeaderComponent {

  constructor() {
    'ngInject';
  }

  $onInit() {
    this.level = this.level || 4;
  }
}

export default angular.module('conduuApp.sectionHeader', [])
  .component('sectionHeader', {
    template: require('./section-header.component.html'),
    bindings: {
      level: '@',
      title: '@',
      icon: '@'
    },
    controller: sectionHeaderComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/section-header/section-header.component.js